export default __webpack_public_path__ + "static/media/camera.653392a8.svg";